import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants, links, mixpanel, compose } from 'common/helpers'
import { useEffect, useCallback } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Modal from 'components/modal/Modal/Modal'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './ProductAddedToQueueModal.scss'


const ProductAddedToQueueModal = (props) => {
  const { name, gender, pathname, data: { product: { brand, name: productName, img } } } = props

  const sequence = 'popup sequence 1'

  const handleButtonClick = useCallback(() => {
    mixpanel.track(constants.analyticsEvents.queuePopupClick, {
      placement: sequence,
    })

    actions.misc.cookies.setItem(constants.cookieNames.discountCoupon, constants.discountCoupons['25_off'])
    actions.view.paymentPage.setCouponWithForcedLowerValue(true)
    actions.models.ui.setClosedPopup(constants.modals.addToQueue.ProductAddedToQueue)
    actions.models.modals.close(name)
  }, [])

  const handleModalClose = useCallback(() => {
    actions.models.ui.setClosedPopup(constants.modals.addToQueue.ProductAddedToQueue)
  }, [])

  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.queuePopup, {
      offer: '25%',
      placement: pathname,
      type: sequence,
      gender,
    })
  }, [])

  return (
    <Modal className={s.modal} name={name} onClose={handleModalClose}>
      <Box mt="24" mb="24">
        <img className={s.image} src={img} alt="" />
        <Box mt="16">
          <Text message={brand} size="14-24" uppercase semibold />
        </Box>
        <Box mt="4">
          <Text message={productName} size="14-24" />
        </Box>
      </Box>
      <Button
        title={messages.subscribe}
        to={links.subscribe}
        size="md"
        color="brand"
        weight="normal"
        fullWidthOnMobile
        uppercase
        onClick={handleButtonClick}
      />
      <Box mt="4">
        <Text message={messages.hint} size="14-24" color="gray" />
      </Box>
    </Modal>
  )
}

ProductAddedToQueueModal.propTypes = {
  name: PropTypes.string.isRequired,
  gender: PropTypes.string, // @connect
  pathname: PropTypes.string, // @connect
  data: PropTypes.shape({
    product: PropTypes.object,
  }),
}

ProductAddedToQueueModal.defaultProps = {
  name: constants.modals.addToQueue.ProductAddedToQueue,
  data: {
    product: {},
  },
}


export default compose(
  connect({
    gender: 'models.me.gender',
    pathname: 'routing.location.pathname',
  })
)(ProductAddedToQueueModal)
